import { Note } from "app/shared/data/note";

export class NoteDTO {

    constructor (
        private idNote: number,
        private ispublic: boolean,
        private title: String,
        private description: String,
        private loctitle: String,
        private loclon: number,
        private loclat: number,
        private localt: number,
        private urlimage: String,
        private urllink: String,
        private source: String
        // cdate, mdate
    ) {
    }

    static build(note: Note): NoteDTO {
        return new NoteDTO(note.idnote, note.ispublic, note.title, note.description, note.loctitle, note.loclon, note.loclat, note.localt, note.urlimage, note.urllink, note.source);
        // datefrom, dateto
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/services/data/NoteDTO.ts